import { useState, useEffect, useMemo } from 'react'
import { ArrowBackIcon, SearchIcon, SmallCloseIcon } from '@chakra-ui/icons'
import {
  Box,
  Badge,
  Button,
  Image,
  HStack,
  Input,
  Stack,
  Text,
  FormControl,
  useMediaQuery,
  Switch,
  VStack,
  SimpleGrid,
  Flex
} from '@chakra-ui/react'
import { Link, useNavigate } from 'react-router-dom'
import { Toaster, toast } from 'react-hot-toast'
import ProductImage from '../../components/ProductImage'
import SessionStartLogo from '../../components/SessionStartLogo'
import useAuth from '../../hooks/useAuth'
import useProduct from '../../hooks/useProduct'
import clientAxios from '../../config/axios'
import LoadingComponents from '../../components/LoadingComponents'
import LogoutHeader from '../../components/LogoutHeader'

const quilmesImages = require.context('../../assets/images', true)

function EditarProductosPorArea () {
  const navigate = useNavigate()
  const [errorId, setErrorId] = useState(0)
  const [isLargerThan768] = useMediaQuery('(min-width: 780px)')
  const [success, setSuccess] = useState('')
  const [successId, setSuccessId] = useState('')
  const { logout, user } = useAuth()
  const [dataArea, setDataArea] = useState([])
  const [productsArea, setProductsArea] = useState([])
  const [loadingProducts, setLoadingProducts] = useState(true)
  const { productsBackend } = useProduct()

  const areaSeleccionada = sessionStorage.getItem('geoAreaDescription')

  const { geoAreaId, description } = JSON.parse(areaSeleccionada)

  useEffect(() => {
    const obtenerProductos = async () => {
      clientAxios.get('/product/all/' + geoAreaId).then((response) => {
        setDataArea(response.data)
        setLoadingProducts(false)
      }).catch((error) => {
        console.log(error)
      })
    }

    obtenerProductos()
  }, [])

  useEffect(() => {
    setProductsArea(dataArea.products)
  }, [dataArea])

  if (loadingProducts) {
    return <LoadingComponents loading={loadingProducts} />
  }

  if (productsArea === undefined) {
    return
  }

  const handleLogout = async () => {
    try {
      await logout()
    } catch (error) {
      console.error(error.message)
    }
  }

  const handleSwitch = (item) => {
    const index = productsArea.findIndex((product) => product.id === item.id)

    if (index === -1) {
      clientAxios.put('/product-status/enable', { productId: item.id, geoAreaId })
        .then((res) => {
          setProductsArea([...productsArea, item])
        })
        .catch((error) => {
          console.log(error)
        })
    } else if (index !== -1) {
      clientAxios.put('/product-status/disable', { productId: item.id, geoAreaId })
        .then((res) => {
          console.log(res)
          const newProductsArea = productsArea.filter((product) => product.id !== item.id)

          setProductsArea(newProductsArea)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setSuccess('¡Listo! Se actualizó la lista')
    setSuccessId(areaSeleccionada)

    setTimeout(() => {
      navigate('/products-area')
    }, 1000)
  }

  return (
    <Stack>
      <Box
        {...(isLargerThan768
          ? { display: 'flex', justifyContent: 'space-between' }
          : { display: 'none' })}
        alignItems={'center'}
        className='logo-home'
        paddingLeft={'5%'}
        paddingRight={'5%'}
      >
        <LogoutHeader />
      </Box>
      <HStack
        alignItems={'center'}
        borderBottom={' 1px solid #E1E1E1'}
        display={'flex'}
        h={'72px'}
        {...(isLargerThan768
          ? { justifyContent: 'space-between' }
          : { justifyContent: 'start' })}
        paddingLeft={'5%'}
        paddingRight={'6%'}
        width={'100%'}
      >

        <Box>
          <Link to={'/products-area'}>
            <ArrowBackIcon
              color={'#0A0808'}
              h={6}
              marginLeft={6}
              marginRight={4}
              w={6}
            />
          </Link>
        </Box >
        <Text fontWeight={'bold'} marginX={'auto'}>
          Productos por área geográfica
        </Text>

        <Button
          {...(isLargerThan768
            ? { display: 'block' }
            : { display: 'none' })}
          _active={{ bg: 'linear-gradient(90deg, #DB580B 0%, #FF883F 100%)' }}
          _hover={{ bg: 'linear-gradient(90deg, #DB580B 0%, #FF883F 100%)' }}
          background={'linear-gradient(90deg, #DB580B 0%, #FF883F 100%)'}
          border-radius={'8px'}
          color={'#FFF'}
          fontSize={'14px'}
          fontWeight={'600'}
          lineHeight={'20px'}
          marginLeft={'auto'}
          width={'10%'}
          onClick={handleSubmit}>
          Guardar
        </Button>

      </HStack>
      <Stack
        background={'#F7F7F7'}
        marginTop={'0rem !important'}
        w={{ base: '100%', md: '100%' }}
      >
        <Box
          className='container-bar'
          display={'flex'}
          flexDirection={'column'}
          flexWrap={'wrap'}
          h='auto'
          justifyContent={'space-around'}
          overflow='auto'
          padding='2rem 1rem'
          w={{ base: '100%', md: '90%' }}
        >
          <Text
            fontSize={'24px'}
          >{description}</Text>
          {productsBackend.length !== 0
            ? (
              <SimpleGrid columns={[2, 3, 4, 5]} height={'fit-content'} paddingTop={'1rem'} spacing='20px'>
                {productsBackend
                  .sort((a, b) =>
                  a.brand === null || b.brand === null? -1 : (
                  a.brand.description.toLowerCase() <
                  b.brand.description.toLowerCase()
                      ? -1
                      : 1 )
                  )
                  .map((item) => (
                    <FormControl
                      key={item.id}
                      background={'#FFF'}
                      borderRadius={'10px'}
                      display={'flex'}
                      flexDirection={'row'}
                      flexWrap={'wrap'}
                      height={'fit-content'}
                      justifyContent={'space-between'}
                      marginTop={'0.5rem'}
                      w={'90%'}
                    >
                      <Stack
                        display={'flex'}
                        flexDirection={'row'}
                        justifyContent={'space-between'}
                        width={'100%'}
                      >
                        <Box w={'100%'}>
                          <Box
                            display={'flex'}
                            flexDirection={'row'}
                            justifyContent={'space-between'}
                          >
                            <Text
                              fontSize='sm'
                              fontWeight='bold'
                              height={'42px'}
                              marginLeft={2}
                              marginTop={3}
                              width={'70%'}
                            >
                              {item.brand !== null? item.brand.description : 'Marca'}
                            </Text>
                            <ProductImage item={item}/>
                          </Box>
                          <Text marginLeft={2} marginTop={0}>
                            {item.volume !== null? item.volume.description : null}
                          </Text>
                          <Stack marginLeft={2} marginTop={2}>
                            <Badge
                              bg={'#E1E1E1'}
                              borderRadius={'10px'}
                              color={'#3B3939'}
                              fontSize={'10px'}
                              fontWeight={'400'}
                              padding={'.1rem .8rem'}
                              w={'max-content'}
                              {...(item.material !== null
                                ? { display: 'block' }
                                : { display: 'none' })}
                            >
                              {item.material !== null ? item.material.description : null }
                            </Badge>
                            <Badge
                              bg={'#E1E1E1'}
                              borderRadius={'10px'}
                              color={'#3B3939'}
                              fontSize={'10px'}
                              fontWeight={'400'}
                              padding={'.1rem .8rem'}
                              w={'max-content'}
                              {...(item.returnability !== null
                                ? { display: 'block' }
                                : { display: 'none' })}
                            >
                              {item.returnability !== null ? item.returnability.description : null}
                            </Badge>
                          </Stack>
                          <Box
                            paddingBottom={3}
                            paddingLeft={2}
                            paddingRight={2}
                            paddingTop={6}
                            width={'150px'}
                          >
                            <Switch
                              colorScheme='orange'
                              /* sin el isChecked marcar los que estan en productArea */
                              isChecked={productsArea.some((product) => product.id === item.id)}

                              size='lg'
                              onChange={() => handleSwitch(item)}
                            />
                          </Box>

                          <Badge
                    bg={'#FBE9BC'}
                    //borderRadius={'10px'}
                    color={'#3B3939'}
                    fontSize={'10px'}
                    fontWeight={'400'}
                    padding={'.1rem .8rem'}
                    textAlign={'center'}
                    w={'100%'}
                    {...(item.brand == null || item.material == null || item.volume == null || item.returnability == null
                      ? { display: 'block' }
                      : { display: 'none' })}
                  >
                    {item.brand == null || item.material == null || item.volume == null || item.returnability == null ? "INCOMPLETO" : null}
                  </Badge>

                        </Box>
                      </Stack>
                    </FormControl>
                  ))}
              </SimpleGrid>
            )
            : (
              <Text>Loading...</Text>
            )}
        </Box>
        <Box
          {...(isLargerThan768
            ? { display: 'none' }
            : { display: 'flex', justifyContent: 'center' })}
          bg={'#FFF'}
          bottom={'2px'}
          boxShadow={' 0px 0px 12px rgba(0, 0, 0, 0.1)'}
          h={'80px'}
          padding={'25px 10px'}
          position={'fixed'}
          width={'100%'}
        >
          <Button
            _active={{ bg: 'linear-gradient(90deg, #DB580B 0%, #FF883F 100%)' }}
            _hover={{ bg: 'linear-gradient(90deg, #DB580B 0%, #FF883F 100%)' }}
            alignSelf={'center'}
            background={'linear-gradient(90deg, #DB580B 0%, #FF883F 100%)'}
            border-radius={'8px'}
            color={'#FFF'}
            fontSize={'14px'}
            fontWeight={'400'}
            lineHeight={'20px'}
            width={'90%'}
            onClick={handleSubmit}
          >
            Guardar
          </Button>
        </Box>
      </Stack>
      {success &&
        toast(
          () => (
            <Flex>
              <Text>{success}</Text>
            </Flex>
          ),
          { id: 'successId' }
        )}
      <Toaster
        position={'bottom-center'}
        toastOptions={{
          duration: 2000,
          style: {
            color: '#FFFFFF',
            backgroundColor: '#3B3939'
          }
        }}
      />
    </Stack>
  )
}

export default EditarProductosPorArea
